/**
 * @generated SignedSource<<8cea3249cc3db9f4f40a8fa3958297cc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteDiscountActionInput = {
  clientMutationId?: string | null;
  discountActionId: string;
};
export type deleteDiscountActionButton_DeleteDiscountActionMutation$variables = {
  input: DeleteDiscountActionInput;
};
export type deleteDiscountActionButton_DeleteDiscountActionMutation$data = {
  readonly Admin: {
    readonly Billing: {
      readonly deleteDiscountAction: {
        readonly clientMutationId: string | null;
      } | null;
    };
  };
};
export type deleteDiscountActionButton_DeleteDiscountActionMutation = {
  response: deleteDiscountActionButton_DeleteDiscountActionMutation$data;
  variables: deleteDiscountActionButton_DeleteDiscountActionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "AdminMutationType",
    "kind": "LinkedField",
    "name": "Admin",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "BillingAdminMutationSchema",
        "kind": "LinkedField",
        "name": "Billing",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "input",
                "variableName": "input"
              }
            ],
            "concreteType": "DeleteDiscountActionPayload",
            "kind": "LinkedField",
            "name": "deleteDiscountAction",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "clientMutationId",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deleteDiscountActionButton_DeleteDiscountActionMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "deleteDiscountActionButton_DeleteDiscountActionMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "041a3e38c49fc09d66bdd9dc309faa42",
    "id": null,
    "metadata": {},
    "name": "deleteDiscountActionButton_DeleteDiscountActionMutation",
    "operationKind": "mutation",
    "text": "mutation deleteDiscountActionButton_DeleteDiscountActionMutation(\n  $input: DeleteDiscountActionInput!\n) {\n  Admin {\n    Billing {\n      deleteDiscountAction(input: $input) {\n        clientMutationId\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "7928a82d777d185e5de445add90387e4";

export default node;
